export class Unidade {
  id: number;
  nome: string;
  ativo?: boolean;
  dtAlteracao?: Date | null;
  dtInclusao?: Date;
}
